import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const OpenFolderFileIcon = createSvgIcon(
  <g className="cd-folder-icon is-open">
    <path
      d="M8.2 13.6c0-1.8 1.5-3.3 3.3-3.3h15.2c.9 0 1.8.4 2.3 1.2l1.9 2.8h21.1c2.1 0 3.8 1.7 3.8 3.8v9.4H8.2V13.6z"
      fill="var(--cd-folder-tab, #e07a1f)"
    />
    <rect
      x="16.2"
      y="12.4"
      width="27.2"
      height="22"
      rx="1.8"
      fill="#ffffff"
    />
    <rect
      x="18.6"
      y="10.6"
      width="26.4"
      height="22"
      rx="1.8"
      fill="#f4f4f4"
    />
    <rect
      x="21.2"
      y="9.2"
      width="25.2"
      height="22"
      rx="1.8"
      fill="#ffffff"
    />
    <path
      d="M6.2 27.2c0-2.4 2-4.4 4.4-4.4h42.8c2.4 0 4.4 2 4.4 4.4v22.2c0 2.4-2 4.4-4.4 4.4H10.6c-2.4 0-4.4-2-4.4-4.4V27.2z"
      fill="var(--cd-folder, #ff5e1f)"
    />
    <path
      d="M10.8 24.2h42.2c1.3 0 2.4.6 3.2 1.5-.7-1.7-2.4-2.9-4.3-2.9H12c-1.8 0-3.4 1-4.2 2.6.8-.8 1.9-1.2 3-1.2z"
      fill="#ffffff"
      opacity="0.24"
    />
  </g>,
  'OpenFolderFileIcon',
);
